(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Overtime-Uniform-Catalog"] && !Shopify.designMode) return;
  try {
    
  // Optional: Add any JavaScript functionality here if needed.

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Overtime-Uniform-Contact"] && !Shopify.designMode) return;
  try {
    
  /* Optional: If your custom code includes JavaScript that needs to be initialized
     after the DOM is loaded, you might add it here. However, in most cases,
     you can include the <script> tags directly in the textarea. */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["RIP-IT-Uniform-Catalog"] && !Shopify.designMode) return;
  try {
    
  // Optional: Add any JavaScript functionality here if needed.

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["RIP-IT-Uniform-Contact"] && !Shopify.designMode) return;
  try {
    
  /* Optional: If your custom code includes JavaScript that needs to be initialized
     after the DOM is loaded, you might add it here. However, in most cases,
     you can include the <script> tags directly in the textarea. */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uniform-faq-hero"] && !Shopify.designMode) return;
  try {
    
  // Optional: Add any JavaScript here

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uniform-faq-page"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
  const faqContainer = document.querySelector('.uniform-faq-page'); // Or '.faq-group__list'

  if (faqContainer) {
    faqContainer.addEventListener('click', function(event) {
      if (event.target.classList.contains('faq-item__question')) {
        const questionButton = event.target;
        const faqItem = questionButton.closest('.faq-item');
        const answerDiv = faqItem.querySelector('.faq-item__answer');
        const iconSpan = questionButton.querySelector('.faq-item__icon');

        if (answerDiv && iconSpan) {
          const expanded = questionButton.getAttribute('aria-expanded') === 'true' || false;
          questionButton.setAttribute('aria-expanded', !expanded);
          answerDiv.setAttribute('aria-hidden', expanded);
          iconSpan.textContent = expanded ? '+' : '-';
        }
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
